import React, { useRef } from 'react'

import { useConfigurationStore, useLuckySpinsStore } from '@stores'
import useScaleToFit from '@hooks/useScaleToFit'
import { useFormatMoney } from '@hooks'
import { useTranslation } from '@amusnet/translations/react'
import { cn } from '@amusnet/react-ui'

interface LuckySpinsOutroContentProps {
    modalTitleStyles: string
}

const LuckySpinsOutroContent: React.FC<LuckySpinsOutroContentProps> = ({ modalTitleStyles }) => {
    const { t } = useTranslation()
    const formatMoney = useFormatMoney()
    const currency = useConfigurationStore((state) => state.currency)

    const totalWin = useLuckySpinsStore((state) => state.totalWin)

    const outroWinAmountContainerRef = useRef<HTMLDivElement>(null)
    const outroWinAmountContentRef = useRef<HTMLDivElement>(null)
    const scaleWinAmount = useScaleToFit(outroWinAmountContainerRef, outroWinAmountContentRef, [totalWin])

    const moneyGradientStyle =
        'bg-[linear-gradient(to_bottom,#ACACAC_0%,#EAF3EE_20%,#E0E0E0_33%,#FFFFFF_50%,#E1E1E1_62%,#CACACA_79%,#CECECE_100%)] bg-clip-text text-transparent'

    if (totalWin === '0') {
        return (
            <>
                <div
                    id="lucky-spins-outro"
                    className="relative w-[700px] z-20 mx-auto pt-[30px] leading-none text-center flex flex-col items-center [&>p]:py-1 [&>p:last-child]:pt-4 [&>p:last-child]:pb-14"
                >
                    <p className="text-2xl py-2 text-white">{t('gameui.bonusSystem.youDidNotScoreAWin')}</p>
                    <p className="text-2xl font-bold text-white">{t('gameui.bonusSystem.betterLuckNextTime')}</p>
                    <p className="text-2xl pt-5 pb-15 text-white">{t('gameui.bonusSystem.playingWithRealMoney')}</p>
                </div>
            </>
        )
    }

    return (
        <>
            <div
                id="lucky-spins-outro"
                className="relative w-[700px] z-20 mx-auto pt-[30px] leading-none font-bold text-center flex flex-col items-center"
            >
                <p className={modalTitleStyles}>{t('gameui.bonusSystem.totalWin')}</p>
                <div
                    ref={outroWinAmountContainerRef}
                    className="flex justify-center items-baseline mt-[20px] mb-[50px] w-[649px] h-[141px]"
                >
                    <div ref={outroWinAmountContentRef} style={{ zoom: scaleWinAmount }}>
                        <span className={cn('text-[120px] mr-[20px] whitespace-nowrap', moneyGradientStyle)}>
                            {formatMoney(+totalWin)}
                        </span>
                        <span className={cn('text-[80px]', moneyGradientStyle)}>{currency}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LuckySpinsOutroContent
